var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUseEmission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 682.667,
    height: 682.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h31.467",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 351.154 247.855)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h31.467",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 351.154 214.388)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-50.885c-7.209 0-13.053-5.844-13.053-13.053v-51.822c0-7.208 5.844-13.052 13.053-13.052H0c7.209 0 13.053 5.844 13.053 13.052v51.822C13.053-5.844 7.209 0 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(304.541 377.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-58.011-41.089c-5.182-3.671-6.504-10.713-2.951-15.728l81.481-115.037c3.552-5.016 10.633-6.106 15.816-2.436l58.011 41.089z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(82.022 183.964)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-81.48 115.037c-3.553 5.016-10.552 6.165-15.633 2.566l-23.77-16.836 94.346-133.201 23.769 16.836C2.313-12 3.553-5.016 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(202.904 83.197)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.479-.346 6.969.57 9.823 2.581l64.046 45.125a24.747 24.747 0 0 0 12.972 4.498c.213 8.442-3.439 18.155-10.483 23.192-11.19 8.001-26.649 5.277-34.529-6.085L-3.36 4.15C-4.308 2.785-5.486 1.632-6.805.678Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(380.057 162.228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-51.646 4.125",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(339.376 166.279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.739 11.732-23.642 14.652-35.055 6.61l-64.046-45.124a14.535 14.535 0 0 0-9.814-2.582l-49.637 4.942c12.921.73 23.882 10.562 25.496 23.814 1.773 14.538-8.377 27.85-22.926 30.074l-110.117 16.837a48.76 48.76 0 0 1-35.448-8.325l-58.841-41.457 67.411-95.173a154.105 154.105 0 0 0 78.405 20.356l99.225-1.209A79.33 79.33 0 0 1-67.69-76.799l60.798 42.836C4.073-26.237 7.373-11.175 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(488.98 203.324)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h84.211c7.746 0 14.086 6.339 14.086 14.086v203.422c0 7.747-6.34 14.085-14.086 14.085h-203.422c-7.747 0-14.086-6.338-14.086-14.085V14.086c0-7.747 6.339-14.086 14.086-14.086H-35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(344.599 272.905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v25.681h-56.329v-89.18c0-3.917 4.349-6.267 7.625-4.123l17.842 11.676a4.927 4.927 0 0 0 5.395 0l17.843-11.676C-4.348-69.766 0-67.416 0-63.499V-35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(355.263 478.818)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseEmission);
export default __webpack_public_path__ + "static/media/UseEmission.de02b48d231e674b32fcb0b43f33f4eb.svg";
export { ForwardRef as ReactComponent };